export const scrollHeader = () => {
  const header = document.querySelector(".header__inner");
  const headerBlock = document.querySelector(".header");
  if(headerBlock && header) {
    const headerHeight = header.offsetHeight;
    // add padding top to header because of fixed header
    headerBlock.style.paddingTop = `${headerHeight}px`;

    window.addEventListener("resize", () => {
      const headerHeight = header.offsetHeight;
      headerBlock.style.paddingTop = `${headerHeight}px`;
    });
  }
};

export default scrollHeader;
